export const SUCCESS_RESEND =
  "Your message has been sent. We will answer you as soon as possible.";

export const NAME_MIN = 2;
export const NAME_MAX = 50;
export const SUBJECT_MIN = 2;
export const SUBJECT_MAX = 100;
export const MESSAGE_MIN = 2;
export const MESSAGE_MAX = 1000;
